import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRight = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.5 15L12.5 10L7.5 5",
			stroke: "currentColor",
			strokeWidth: 1.67,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgRight;
